import { withTranslation } from "react-i18next";
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Input } from 'reactstrap';
import { verifyProperty } from 'store/slices/businessSlice';
import InitPropertyVerification from './InitPropertyVerification';
import Loading from '../../Loading';
export class VerifyBusinessPhone extends Component {
  constructor(props) {
    super(props);
    this.state = {
      code: Array(4).fill(''),
      loading: false,
      error: null
    };

    for (let i of [0, 1, 2, 3]) {
      this[`code-${i}`] = React.createRef();
    }

    this.changeCode = this.changeCode.bind(this);
    this.sendCode = this.sendCode.bind(this);
  }

  changeCode(event) {
    const value = event.target.value.slice(-1);
    const id = parseInt(event.target.id);
    this.setState(({
      code
    }) => {
      const newCode = code.map((oldValue, key) => key === id ? value : oldValue);
      return {
        code: newCode
      };
    }, () => {
      if (id < 3) {
        this[`code-${id + 1}`].current.focus();
      }

      if (this.state.code.every(value => value !== '')) {
        this.sendCode(this.state.code.join(''));
      }
    });
  }

  sendCode(code) {
    this.setState({
      loading: true
    });
    this.props.verifyProperty(this.props.property.objectId, code).then(res => {
      if (!res.success) {
        this.setState({
          error: 'Verification failed',
          loading: false,
          code: Array(4).fill('')
        });
      } // If success don't update the state because the component will be unmounted

    }).catch(err => this.setState({
      error: err.message,
      code: Array(4).fill(''),
      loading: false
    }));
  }

  render() {
    const {
      code,
      loading,
      error
    } = this.state;
    const {
      property,
      t
    } = this.props;
    return <>
        <Row className='d-block'>
          <Col xs={12}>
            <p>{t("Please enter the code from the SMS")}</p>
          </Col>
          <Col className='d-flex flex-nowrap'>
            {[0, 1, 2, 3].map(i => <Input id={i} type='string' value={code[i]} onChange={this.changeCode} key={i} placeholder='0' style={{
            width: '40px',
            height: '40px'
          }} innerRef={this[`code-${i}`]} disabled={loading} />)}
            {loading && <div className='position-relative mx-5'><Loading /></div>}
          </Col>
        </Row>
        {error && <Row>
            <Col>
              <p className='text-danger pt-2'>{error}</p>
            </Col>
          </Row>}
        <Row>
          <Col>
            <div className='pt-2'>{t("Haven't received the code?")}{' '}
              <InitPropertyVerification title={'Send again'} propertyId={property.objectId} />
            </div>
          </Col>
        </Row>
      </>;
  }

}

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({
  verifyProperty: (propertyId, code) => dispatch(verifyProperty(propertyId, code))
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(VerifyBusinessPhone));